/* global femcare, Swiper */

femcare.gallery.innovation = {
    init: function () {
        var $innovations = $('.innovations');

        if ($innovations.length) {
            $innovations.each(function (index, element) {
                var $slider = $(element);

                new Swiper($slider.find('.swiper-container')[0], {
                    slidesPerView: 'auto',
                    breakpoints: {
                        350: {
                            spaceBetween: 15
                        },

                        1200: {
                            spaceBetween: 30
                        }
                    },
                    mousewheel: {
                        forceToAxis: true
                    }
                });
            });
        }
    }
};